import { apiFactory } from "../api_factory";

export const seriesTrendsApi = apiFactory({
  path: `/pcc/v1/series/`
});
